
const nss_oil_change_modal = {
    init: () => {
        const nssOilChangeEls = document.querySelectorAll('[nss-oil-change-modal]');
        const nssOilChangeTriggerEls = document.querySelectorAll('[nss-oil-change-modal-trigger], [href="#oil-change-modal"]');
        const nssOilChangeCloseTriggerEls = document.querySelectorAll('[nss-oil-change-modal-close]');

        [...nssOilChangeTriggerEls].forEach(nssOilChangeTriggerEl => {
            nssOilChangeTriggerEl.addEventListener('click', (e) => {
                e.preventDefault();
                if (nssOilChangeEls[0]) {
                    nssOilChangeEls[0].classList.add('active');
                }
            });
        });

        [...nssOilChangeEls].forEach(nssOilChangeEl => {
            const accordionEls = nssOilChangeEl.querySelectorAll('[nss-oil-change-faq]');
            const accordionTriggers = nssOilChangeEl.querySelectorAll('[nss-oil-change-faq-trigger]');

            nssOilChangeEl.addEventListener('click', (e) => {
                if (e.target == e.currentTarget) {
                    e.preventDefault();
                    e.stopPropagation();
                    nssOilChangeEl.classList.remove('active');
                }
            });

            [...accordionTriggers].forEach(accordionTrigger => {
                accordionTrigger.addEventListener('click', () => {
                    const accordionWrapper = accordionTrigger.closest('[nss-oil-change-faq]');
                    if (accordionWrapper) {
                        [...accordionEls].filter(accordionEl => {return accordionEl != accordionWrapper}).forEach(accordionEl => {
                            accordionEl.classList.remove('active');
                        });
                        accordionWrapper.classList.toggle('active');
                    }
                });
            });
        });

        [...nssOilChangeCloseTriggerEls].forEach(nssOilChangeCloseTriggerEl => {
            nssOilChangeCloseTriggerEl.addEventListener('click', () => {
                const targetModal = nssOilChangeCloseTriggerEl.closest('[nss-oil-change-modal]');
                if (targetModal) {
                    targetModal.classList.remove('active');
                }
            });
        });
    }
}

export default nss_oil_change_modal;
